import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入 ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

// 引入进度条样式
import 'nprogress/nprogress.css'
import { setAmapSecurityConfig } from '@/utils/amapConfig'
import dayjs from 'dayjs';
// 引入高德地图插件
import AMapPlugin from './plugins/amap';


// 在应用启动时设置安全密钥
setAmapSecurityConfig()
// 全局注册 ElementUI
Vue.use(ElementUI)
Vue.use(AMapPlugin); // 注册高德地图插件，使this.$createAMap生效
Vue.config.productionTip = false
// 全局挂载dayjs
Vue.prototype.$dayjs = dayjs;

// 统一处理后端“data.error”错误结构（适用于所有 await axios.*）
axios.interceptors.response.use(
  (response) => {
    try {
      const body = response && response.data ? response.data : null
      const err = body && body.data && body.data.error != null ? String(body.data.error).trim() : ''
      if (err) {
        body.msg = err
        body.success = false
      }
    } catch (e) {
      /* ignore */
    }
    return response
  },
  (error) => Promise.reject(error)
)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
